var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlus2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8169"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8167"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 111",
    style: {
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8168"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 314",
    transform: "translate(3.499 8.664)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    },
    d: "M0 0h10.816"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 315",
    transform: "rotate(90 2.826 6.081)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    },
    d: "M0 0h10.816"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus2);
export default __webpack_public_path__ + "static/media/circle_plus2.8ee297ba0da9f27f69050f7004db5ef5.svg";
export { ForwardRef as ReactComponent };